// Migrado VERBATIM de context/DarkMode/index.js (THEME_CONFIGS.corporate).
import { sharedComponents } from "./shared";

export default {
  muiMode: "light",
  scrollbarColor: "#273A74",
  palette: {
    primary:    { main: "#273A74" },
    secondary:  { main: "#0071BC" },
    background: { default: "#EEF2F7", paper: "#FFFFFF" },
    text:       { primary: "#1A2645", secondary: "#4A5568" },
    divider:    "#D1D9E6",
  },
  components: {
    ...sharedComponents,
    MuiOutlinedInput: {
      styleOverrides: {
        root: { borderRadius: 6 },
        notchedOutline: { borderColor: "#C4CEDE" },
      },
    },
  },
  custom: {
    chat: { sentBg: "#E3EAF8", quotedSentBg: "#C8D8F4", quotedReceivedBg: "#f0f0f0", accent: "#273A74" },
    chartPalette: ["#273A74", "#0071BC", "#4CAF50", "#E74C3C", "#8B5CF6", "#F37021"],
    login: { bg: "#555A5F" },
  },
};
